import { Box, Button, Grid } from "@material-ui/core";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { DateRange } from "@mui/lab/DateRangePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import MobileDateRangePicker from "@mui/lab/MobileDateRangePicker";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { TransitionProps } from "@mui/material/transitions";
import axios from "axios";
import jaLocale from "date-fns/locale/ja";
import React from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../Const";
import { useLoadingOverlay } from "../../utilHooks/loadingOverlay";
import GenericTemplate from "../templates/GenericTemplate";

//  form modules
import { yupResolver } from "@hookform/resolvers/yup";
import { SubmitHandler, useForm } from "react-hook-form";
import * as yup from "yup";

// 型定義
// フォーム送信用の型
interface ConstructionSubmitFormType {
  const_name: string;
  setuser_name: string;
  orderer: string;
  constOverview: string;
  startDate: string;
  endDate: string;
}

// // バリデーションルール
const ConstructionSchema = yup.object({
  const_name: yup
    .string()
    .required("必須項目です")
    .max(25, "25文字以内で入力してください。"),
  setuser_name: yup
    .string()
    .required("必須項目です")
    .max(25, "25文字以内で入力してください。"),
  orderer: yup
    .string()
    .required("必須項目です")
    .max(25, "25文字以内で入力してください。"),
  // テキストボックスを大きくした。200文字で一度見てもらう。
  // 例：私が貴社を志望したのは、メイクをきっかけに一人でも多くのお客様に自信を持っていただきたいからです。私はメイクをただの作業ではなく、明るく前向きな気持ちにしてくれる魔法だと考えています。過去に貴社の美容部員の方にメイクをしていただいたことがあり、メイクで姿勢や性格まで変えられるのだと驚きました。入社後は以前の私のように自信が持てずにいるお客様に、メイクを通して美と自信を届けたいです。
  constOverview: yup.string().required("必須項目です").max(200, "200文字以下で入力してください。"),
  startDate: yup.string().required("必須項目です。"),
  endDate: yup.string().required("必須項目です。"),
});

/* ダイアログ関連*/
const Transition: any = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

/* ダイアログ関連*/

// React Component
const ConstructionCreat: React.FC = () => {
  /*ローカルストレージ取得*/
  let jsonlist: any = JSON.parse(localStorage.getItem("datalist") || "{}");

  // ローデイングモジュール
  const { openLoading, closeLoading } = useLoadingOverlay();

  /*スピナー処理*/
  const [loading, setLoading] = React.useState<boolean>(false);
  const [success, setSuccess] = React.useState<boolean>(false);
  /*スピナー処理*/

  /*ダイアログ処理*/
  const [open, setOpen] = React.useState<boolean>(false);
  const handleClickOpen: any = () => {
    setOpen(true);
  };
  const handleClose: any = () => {
    setOpen(false);
  };
  /*ダイアログ処理*/

  // カレンダーに必要なuseState Value
  const [value, setValue] = React.useState<DateRange<Date>>([null, null]);

  // react-hook-formとyupを紐づける。
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ConstructionSubmitFormType>({
    resolver: yupResolver(ConstructionSchema),
  });

  // 作成ボタンを押した時の挙動
  const onSubmit: SubmitHandler<ConstructionSubmitFormType> = (data) => {
    // バリデーションチェックOK後に処理する内容を記述する。

    // 送信されたデータを確認する。
    console.log(data);
    console.log(data.endDate);

    /*スピナー*/
    if (!loading) {
      setSuccess(false);
      setLoading(true);
    }

    // POST処理。工事新規作成APIを呼び出し、下記情報を送信する。
    openLoading();
    axios
      .post(
        API_URL.CONSTRUCTION_CREATE,
        {
          /*
          "company_id":"sampleCompany1",
         "dealer_info_id" : "sampleCompany1",
         "construction_name":"工事名2",
         "address":"工事名2住所",
         "user_name":"請負者名",
         "contractor": "契約者？",
         "orderer":"発注者名",
         "start_date":"20220501",
         "end_date":"20221130",
         "overview":"ここは工事の概要入力欄です。"
         */
          company_id: jsonlist.user.company_id,
          dealer_info_id: jsonlist.user.dealer_info_id,
          construction_name: data.const_name,
          user_name: data.setuser_name,
          orderer: data.orderer,
          overview: data.constOverview,
          start_date: data.startDate,
          end_date: data.endDate,
        },
        { headers: { Authorization: jsonlist.token.IdToken } }
      )
      .then((res) => {
        setSuccess(true);
        setLoading(false);
        handleClickOpen();
        console.log(res);
      })
      .catch((error) => {
        setSuccess(true);
        setLoading(false);
        console.log(error);
      })
      .finally(() => {
        closeLoading();
      });
  };

  return (
    <GenericTemplate title="工事の新規作成">
      <div>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ color: "#0d47a1" }}>
            {"新規登録が完了しました"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description"></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              style={{ color: "#fff", backgroundColor: "#1e88e5" }}
              component={Link}
              to={{ pathname: "/Constructionlist" }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}>
        {/* 工事名テキストインプットフィールド */}
        <Grid container spacing={0}>
          <Grid item xs={2} className="detail-title">
            工事名
          </Grid>
          <Grid item xs={10}>
            <TextField
              // onChange={change_const_name}
              required
              type="text"
              sx={{ width: "70%" }}
              {...register("const_name")}
              error={"const_name" in errors}
              helperText={errors.const_name?.message}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        {/* 請負者テキストインプットフィールド */}
        <Grid container spacing={0}>
          <Grid item xs={2} className="detail-title">
            請負者
          </Grid>
          <Grid item xs={10}>
            <TextField
              // onChange={change_user_name}
              required
              type="text"
              {...register("setuser_name")}
              error={"setuser_name" in errors}
              helperText={errors.setuser_name?.message}
            />
          </Grid>
        </Grid>
      </Stack>

      {/* 発注者テキストインプットフィールド */}
      <Stack spacing={3} margin={2}>
        <Grid container spacing={0}>
          <Grid item xs={2} className="detail-title">
            発注者
          </Grid>
          <Grid item xs={10}>
            <TextField
              // onChange={change_orderer}
              required
              type="text"
              {...register("orderer")}
              error={"orderer" in errors}
              helperText={errors.orderer?.message}
            />
          </Grid>
        </Grid>
      </Stack>

      {/* 概要テキストインプットフィールド */}
      <Stack spacing={3} margin={2}>
        <Grid container spacing={0} justifyContent="center">
          <Grid item xs={2} className="detail-title">
            工事の概要
          </Grid>
          <Grid item xs={10}>
            <TextField
              // onChange={change_overview}
              required
              type="text"
              fullWidth
              multiline
              rows={4}
              {...register("constOverview")}
              error={"constOverview" in errors}
              helperText={errors.constOverview?.message}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}>
        {/* 工期フィールド */}
        <Grid container spacing={0} justifyContent="flex-start">
          <Grid item xs={2} className="detail-title">
            工期
          </Grid>
          <Grid item xs={10}>
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              locale={jaLocale}
            >
              <MobileDateRangePicker
                startText="開始時期"
                endText="終了時期"
                value={value}
                onChange={(newValue) => {
                  setValue(newValue);
                }}
                renderInput={(startProps, endProps) => (
                  <React.Fragment>
                    {/* バリーデーションルールを追加しても、エラーが消えない。 */}
                    <TextField
                      {...startProps}
                      {...register("startDate")}
                      error={"startDate" in errors}
                      helperText={errors.startDate?.message}
                    />
                    <Box sx={{ mx: 2 }}> 〜 </Box>
                    {/* バリーデーションルールを追加しても、エラーが消えない。 */}
                    <TextField
                      {...endProps}
                      {...register("endDate")}
                      error={"endDate" in errors}
                      helperText={errors.endDate?.message}
                    />
                  </React.Fragment>
                )}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>

        <Stack spacing={3} margin={2}></Stack>

        <Stack spacing={0} margin={0}>
          <Grid container spacing={0}>
            {/* 作成ボタンフィールド */}
            <Grid item xs={2}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ m: 1, position: "relative" }}>
                  <Button
                    color="primary"
                    variant="contained"
                    disabled={loading}
                    size="large"
                    // onClick={clickSubmit}
                    onClick={handleSubmit(onSubmit)}
                  >
                    作成
                  </Button>
                  {loading && (
                    <CircularProgress
                      size={24}
                      sx={{
                        color: green[500],
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        marginTop: "-12px",
                        marginLeft: "-12px",
                      }}
                    />
                  )}
                </Box>
              </Box>
            </Grid>

            {/* キャンセルボタンフィールド */}
            <Grid item xs={2}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ m: 1, position: "relative" }}>
                  <Button
                    color="primary"
                    variant="contained"
                    size="large"
                    component={Link}
                    to={{ pathname: "/Constructionlist" }}
                  >
                    キャンセル
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Stack>
      </Stack>
    </GenericTemplate>
  );
};

export default ConstructionCreat;
